import { useEffect, useState } from "react";
import api from "../api";
import { Leaf, X } from "lucide-react";
import { trackEvent } from "../lib/analytics";

const DISMISS_KEY = "bb_app_banner_dismissed";
const DISMISS_DAYS = 30;

export default function GetAppBanner() {
  const [cfg, setCfg] = useState(null);

  useEffect(() => {
    const isAndroid = /android/i.test(navigator.userAgent);
    const standalone =
      window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    let dismissed = false;
    try {
      const t = localStorage.getItem(DISMISS_KEY);
      dismissed = t && Date.now() - Number(t) < DISMISS_DAYS * 864e5;
    } catch (err) { console.debug("localStorage unavailable:", err?.name); }
    if (!isAndroid || standalone || dismissed) return;
    api.get("/settings/public")
      .then(({ data }) => { if (data.play_store_live && data.play_store_url) setCfg(data); })
      .catch(() => {});
  }, []);

  if (!cfg) return null;

  const dismiss = () => {
    try { localStorage.setItem(DISMISS_KEY, String(Date.now())); } catch (err) { console.debug("localStorage unavailable:", err?.name); }
    trackEvent("app_banner_dismissed");
    setCfg(null);
  };

  return (
    <>
      <style>{`body { padding-bottom: 68px; }`}</style>
      <div
        className="fixed bottom-0 inset-x-0 z-40 bg-[#1A2F25] text-[#F9F6F0] px-4 py-3 flex items-center gap-3 shadow-2xl"
        data-testid="get-app-banner"
      >
      <div className="w-10 h-10 rounded-xl bg-[#2D4A3E] flex items-center justify-center flex-shrink-0">
        <Leaf className="w-5 h-5 text-[#D47C59]" strokeWidth={1.5} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium leading-tight">Get the Backyard Buddy app</p>
        <p className="text-xs text-[#E5E0D8] font-light">Free on Google Play</p>
      </div>
      <a
        href={cfg.play_store_url}
        target="_blank"
        rel="noreferrer"
        onClick={() => trackEvent("app_banner_clicked")}
        className="btn-accent text-sm py-2 px-4 flex-shrink-0"
        data-testid="get-app-banner-cta"
      >
        Get app
      </a>
      <button onClick={dismiss} className="p-1 text-[#E5E0D8] hover:text-white flex-shrink-0" data-testid="get-app-banner-dismiss">
        <X className="w-4 h-4" />
      </button>
      </div>
    </>
  );
}
